import controller from './account-details.controller';

const template = require('./account-details.html');

export default {
    bindings: {
        serviceAccount: '<',
        onUpdate: '&',
        onDelete: '&'
    },
    controller,
    template
};
